export default {
  disabled: {
    title: 'A faturação não é gerida na plataforma',
    description:
      'As subscrições e faturas não estão disponíveis porque a faturação entre si e os seus restaurantes é processada fora da plataforma. Os pagamentos, extratos e relatórios continuam disponíveis.',
  },
};
